// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.plugins-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: clip;
}

div.map-container {
    position: absolute;
}

div.app-infos-container {
    position: absolute;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap-reverse;
    z-index: 2;
    overflow: hidden;
    padding: .5em .5em 2.5em .5em;
    row-gap: 0.25em;
}

div.map-bottom-tool-container {
    z-index: 3;
    position: absolute;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

div.map-bottom-tool-container > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: -1px;
    pointer-events: initial;
    padding: 0.25em 0.5em;
    gap: 1em;
    background-color: var(--container-bg-color);
    box-shadow: 0px -2px 4px rgba(136, 136, 136, 0.5);
    border-radius: var(--border-radius) var(--border-radius) 0px 0px;
    padding-right: 20px;
    padding-left: 20px;
}

div.map-bottom-tool-container > div:empty {
    display: none;
}

div.app-info {
    z-index: 1;
    color: var(--panel-text-color);
    background-color: var(--panel-bg-color);
    box-shadow: 0 0 4px rgba(136, 136, 136, 0.5);
    padding: 0.25em;
    display: flex;
    align-items: center;
}


div.map-buttons-container {
    position: absolute;
    pointer-events: none;
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap-reverse;
    z-index: 2;
    overflow: hidden;
    padding: 2em 1em 2.5em 1em;
}

div.map-buttons-spacer {
    display: inline-block;
    width: 1em;
    max-height: 4em;
    flex: 1 1 auto;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/style/PluginsContainer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,QAAQ;IACR,2CAA2C;IAC3C,iDAAiD;IACjD,gEAAgE;IAChE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,uCAAuC;IACvC,4CAA4C;IAC5C,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,cAAc;AAClB","sourcesContent":["div.plugins-container {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    overflow: clip;\n}\n\ndiv.map-container {\n    position: absolute;\n}\n\ndiv.app-infos-container {\n    position: absolute;\n    pointer-events: none;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    align-content: flex-start;\n    justify-content: flex-start;\n    flex-wrap: wrap-reverse;\n    z-index: 2;\n    overflow: hidden;\n    padding: .5em .5em 2.5em .5em;\n    row-gap: 0.25em;\n}\n\ndiv.map-bottom-tool-container {\n    z-index: 3;\n    position: absolute;\n    pointer-events: none;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n}\n\ndiv.map-bottom-tool-container > div {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-end;\n    margin-bottom: -1px;\n    pointer-events: initial;\n    padding: 0.25em 0.5em;\n    gap: 1em;\n    background-color: var(--container-bg-color);\n    box-shadow: 0px -2px 4px rgba(136, 136, 136, 0.5);\n    border-radius: var(--border-radius) var(--border-radius) 0px 0px;\n    padding-right: 20px;\n    padding-left: 20px;\n}\n\ndiv.map-bottom-tool-container > div:empty {\n    display: none;\n}\n\ndiv.app-info {\n    z-index: 1;\n    color: var(--panel-text-color);\n    background-color: var(--panel-bg-color);\n    box-shadow: 0 0 4px rgba(136, 136, 136, 0.5);\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n}\n\n\ndiv.map-buttons-container {\n    position: absolute;\n    pointer-events: none;\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    align-content: flex-start;\n    justify-content: flex-start;\n    flex-wrap: wrap-reverse;\n    z-index: 2;\n    overflow: hidden;\n    padding: 2em 1em 2.5em 1em;\n}\n\ndiv.map-buttons-spacer {\n    display: inline-block;\n    width: 1em;\n    max-height: 4em;\n    flex: 1 1 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
